// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app_app__QaPWV {
  overflow-x: hidden;
}

.app_desctop__i0YYo {
  display: none;
}

.app_mob__PBCMq {
  display: block;
}

.app_button__eYmpq {
  margin-top: 30px;
  width: 315px;
}
@media (max-width: 479px) {
  .app_button__eYmpq {
    margin-top: 20px;
  }
}

.app_hiddeDesck__xpi\\+P {
  display: none !important;
}

.app_displayMob__65y5Y {
  display: block !important;
}

@media (min-width: 475px) {
  .app_mob__PBCMq {
    display: none;
    width: 375px;
    margin: 0 auto;
  }
  .app_desctop__i0YYo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100vh;
    background: #00D1D2;
    background-blend-mode: color-dodge;
    color: #fff;
    font-style: normal;
    letter-spacing: 0;
    text-align: center;
  }
  .app_desctop__i0YYo h1 {
    margin: 0;
    width: 603px;
    font-size: 50px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
    color: #fff;
  }
}
@media (min-width: 475px) and (max-width: 479px) {
  .app_desctop__i0YYo h1 {
    width: 315px;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
  }
}
@media (min-width: 475px) {
  .app_desctop__i0YYo .app_description__B29jd {
    margin: 0 auto;
    margin-top: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
}
@media (min-width: 475px) and (max-width: 479px) {
  .app_desctop__i0YYo .app_description__B29jd {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
}
@media (min-width: 475px) {
  .app_desctop__i0YYo p {
    width: 426px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    margin-bottom: 78px;
    color: #fff;
    text-align: center;
  }
}
@media (min-width: 475px) and (max-width: 479px) {
  .app_desctop__i0YYo p {
    width: 315px;
    margin-bottom: 18px;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
.app_loader__\\+1z7G {
  position: fixed;
  z-index: 999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: none;
  background-color: rgba(255, 255, 255, 0.7);
}
.app_loader__\\+1z7G:after {
  width: 30px;
  height: 30px;
  content: "";
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  display: block;
  margin-left: -0.4rem;
  margin-top: -0.4rem;
  padding: 0;
  background: transparent;
  border: 0.1rem solid #34303d;
  border-right-color: transparent;
  border-top-color: transparent;
  border-radius: 50%;
  opacity: 1;
  animation: app_spin__FR9Ae 500ms infinite linear;
}

.app_loader-loading__fnw\\+y {
  display: block;
}

@keyframes app_spin__FR9Ae {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/app/app.module.scss","webpack://./src/styles/common/media.scss","webpack://./src/styles/common/mixins.scss"],"names":[],"mappings":"AAEA;EAOI,kBAAA;AAPJ;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,gBAAA;EACA,YAAA;AARJ;ACEE;EDIF;IAKQ,gBAAA;EAPN;AACF;;AAUA;EACI,wBAAA;AAPJ;;AAUA;EACI,yBAAA;AAPJ;;AAUA;EACI;IACI,aAAA;IACA,YAAA;IACA,cAAA;EAPN;EAWE;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,kCAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;EATN;EAYM;IACI,SAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;EAVV;AACF;AC5CE;ED8CM;IAUQ,YAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EARd;AACF;AAhCA;EA2CQ;IACI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EARV;AACF;AC/DE;EDgEM;IASQ,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EANd;AACF;AAlDA;EA2DQ;IACI,YAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,WAAA;IACA,kBAAA;EANV;AACF;ACnFE;EDgFM;IAWQ,YAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EAJd;AACF;AAUA;EACI,eAAA;EAEA,YAAA;EAEA,MAAA;EAEA,SAAA;EAEA,OAAA;EAEA,QAAA;EAEA,aAAA;EAEA,0CAAA;AAfJ;AAiBI;EE9HF,WF+HoB;EE9HpB,YF8HoB;EAEd,WAAA;EAEA,kBAAA;EAEA,UAAA;EAEA,QAAA;EAEA,SAAA;EAEA,cAAA;EAEA,oBAAA;EAEA,mBAAA;EAEA,UAAA;EAEA,uBAAA;EAEA,4BAAA;EAEA,+BAAA;EAEA,6BAAA;EAEA,kBAAA;EAEA,UAAA;EAEA,gDAAA;AA9BR;;AAkCA;EACI,cAAA;AA/BJ;;AAkCA;EACI;IACI,uBAAA;EA/BN;EAkCE;IACI,yBAAA;EAhCN;AACF","sourcesContent":["@import 'src/styles/core';\n\n.app {\n    // @include desktop {\n    //     width: 375px;\n    //     margin: 0 auto;\n\n    // }\n\n    overflow-x: hidden;\n}\n\n\n.desctop {\n    display: none;\n}\n\n.mob {\n    display: block;\n}\n\n.button {\n    margin-top: 30px;\n    width: 315px;\n\n    @include mobile () {\n        margin-top: 20px;\n    }\n}\n\n.hiddeDesck {\n    display: none !important;\n}\n\n.displayMob {\n    display: block !important;\n}\n\n@media (min-width: 475px) {\n    .mob {\n        display: none;\n        width: 375px;\n        margin: 0 auto;\n    }\n\n\n    .desctop {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-direction: column;\n        overflow: hidden;\n        position: relative;\n        width: 100%;\n        height: 100vh;\n        background: #00D1D2;\n        background-blend-mode: color-dodge;\n        color: #fff;\n        font-style: normal;\n        letter-spacing: 0;\n        text-align: center;\n\n\n        h1 {\n            margin: 0;\n            width: 603px;\n            font-size: 50px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 140%;\n            color: #fff;\n\n            @include mobile () {\n                width: 315px;\n                font-size: 32px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 130%;\n            }\n        }\n\n        .description {\n            margin: 0 auto;\n            margin-top: 10px;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 130%;\n\n            @include mobile () {\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 130%;\n            }\n        }\n\n        p {\n            width: 426px;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 130%;\n            margin-bottom: 78px;\n            color: #fff;\n            text-align: center;\n\n            @include mobile () {\n                width: 315px;\n                margin-bottom: 18px;\n                font-size: 10px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 120%;\n            }\n        }\n    }\n\n}\n\n.loader {\n    position: fixed;\n\n    z-index: 999;\n\n    top: 0;\n\n    bottom: 0;\n\n    left: 0;\n\n    right: 0;\n\n    display: none;\n\n    background-color: rgba(255, 255, 255, 0.7);\n\n    &:after {\n        @include size(30px);\n\n        content: '';\n\n        position: absolute;\n\n        z-index: 1;\n\n        top: 50%;\n\n        left: 50%;\n\n        display: block;\n\n        margin-left: -0.4rem;\n\n        margin-top: -0.4rem;\n\n        padding: 0;\n\n        background: transparent;\n\n        border: 0.1rem solid $dark-grey;\n\n        border-right-color: transparent;\n\n        border-top-color: transparent;\n\n        border-radius: 50%;\n\n        opacity: 1;\n\n        animation: spin 500ms infinite linear;\n    }\n}\n\n.loader-loading {\n    display: block;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}","$tablet-bp: 660px;\n$desktop-bp: 479px;\n\n\n@mixin tablet() {\n  @media (min-width: #{$tablet-bp}) {\n    @content;\n  }\n}\n\n@mixin tablet-only() {\n  @media (min-width: #{$tablet-bp}) and (max-width: #{$desktop-bp}) {\n    @content;\n  }\n}\n\n@mixin mobile() {\n  @media (max-width: 479px) {\n    @content;\n  }\n}\n\n@mixin desktop() {\n  @media (min-width: #{$desktop-bp}) {\n    @content;\n  }\n}","@mixin flex($justify: flex-start, $align: center, $direction: row) {\n  display: flex;\n\n  flex-direction: $direction;\n\n  justify-content: $justify;\n\n  align-items: $align;\n}\n\n@mixin size($size) {\n  width: $size;\n  height: $size;\n}\n\n@mixin min-size($size) {\n  min-width: $size;\n  min-height: $size;\n}\n\n@mixin force-size($size) {\n  @include size($size);\n  @include min-size($size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `app_app__QaPWV`,
	"desctop": `app_desctop__i0YYo`,
	"mob": `app_mob__PBCMq`,
	"button": `app_button__eYmpq`,
	"hiddeDesck": `app_hiddeDesck__xpi+P`,
	"displayMob": `app_displayMob__65y5Y`,
	"description": `app_description__B29jd`,
	"loader": `app_loader__+1z7G`,
	"spin": `app_spin__FR9Ae`,
	"loader-loading": `app_loader-loading__fnw+y`
};
export default ___CSS_LOADER_EXPORT___;
